import styled from 'styled-components';

export const InputError = styled.div`
  margin: 10px 0;
  padding: 10px;
  background: rgb(210, 30, 20);
  color: rgb(255, 255, 255);
  font-size: 14px;
`;
